import React from 'react';

const ScoreProgressBar = ({ value, color }) => {
  // Ensure value is between 0 and 100
  const normalizedValue = Math.min(Math.max(value, 0), 100);
  
  // Special positioning for 100% value
  const valuePosition = normalizedValue === 100 
    ? { right: '8px', left: 'auto' } 
    : { left: `calc(${normalizedValue}% + 8px)`, right: 'auto' };

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "24px",
        backgroundColor: "#f5f5f5",
        borderRadius: "12px",
        overflow: "hidden", // Contains the progress bar within bounds
      }}
    >
      <div
        style={{
          position: "absolute",
          height: "100%",
          width: `${normalizedValue}%`,
          backgroundColor: color,
          borderRadius: normalizedValue === 100 ? "12px" : "12px 0 0 12px",
          display: "flex",
          alignItems: "center",
          transition: "width 0.3s ease-in-out",
        }}
      >
        {/* For 100% value, show the label inside the bar */}
        {normalizedValue === 100 && (
          <div
            style={{
              position: "absolute",
              right: "8px",
              color: "#fff", // White text for contrast
              fontWeight: "bold",
              fontSize: "14px",
              fontFamily: 'Outfit',
            }}
          >
            100%
          </div>
        )}
      </div>

      {/* Starting value (0%) */}
      {normalizedValue !== 0 && (
        <div
          style={{
            position: "absolute",
            left: "8px",
            display: "flex",
            alignItems: "center",
            height: "100%",
            fontFamily: 'Outfit',
            color: normalizedValue > 0 ? "transparent" : "#666",
          }}
        >
          0%
        </div>
      )}

      {/* Value Label (placed dynamically outside the bar, except for 100%) */}
      {normalizedValue !== 100 && (
        <span
          style={{
            position: "absolute",
            ...valuePosition,
            top: "50%",
            transform: "translateY(-50%)",
            fontSize: "14px",
            fontWeight: "bold",
            fontFamily: 'Outfit',
            color: color,
            whiteSpace: "nowrap", // Prevents text wrapping
          }}
        >
          {`${normalizedValue}%`}
        </span>
      )}

      {/* End value (100%) */}
      {normalizedValue !== 100 && (
        <div
          style={{
            position: "absolute",
            right: "8px",
            display: "flex",
            alignItems: "center",
            fontFamily: 'Outfit',
            height: "100%",
            color: "#666",
          }}
        >
          100%
        </div>
      )}
    </div>
  );
};

export default ScoreProgressBar;